import EA from 'helpers/init';
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText, ScrollTrigger);

export default EA.Methods.heroDetailAnim = ($this) => {
    const icon = $this.querySelector('.hero-detail-svg');
    const titleEl = $this.querySelector('.hero-detail-title');
    const text = $this.querySelectorAll('.hero-detail-text');

    const splitLines = new SplitText(titleEl, { type: 'lines' });
    const splitChars = new SplitText(splitLines.lines, { type: 'chars' });

    gsap.config({ nullTargetWarn: false });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: $this,
            // .hero-detail-block sits inside the pinned .hero-section (see
            // heroSequence.js PHASE A, id: 'heroPin'), so its natural
            // getBoundingClientRect position doesn't include the pin's
            // consumed scroll distance - compensate for it here.
            start: () => {
                const pinST = ScrollTrigger.getById('heroPin');
                const pinOffset = pinST ? pinST.end - pinST.start : 0;
                return `top+=${pinOffset} 70%`;
            }
        }
    });

    gsap.config({nullTargetWarn: false});

    tl
        .from(icon, {
            alpha: 0,
            duration: 0.3,
            ease: 'power2.out',
            clearProps: 'all'
        },)
        .from(splitChars.chars, {
            y: 10,
            alpha: 0,
            duration: 0.35,
            stagger: 0.025,
            ease: 'power3.out',
            onComplete: () => {
                splitChars.revert();
                splitLines.revert();
            }
        }, '-=0.2')
        .from(text, {
            alpha: 0,
            duration: 0.35,
            ease: 'power2.out',
            clearProps: 'all'
        }, '-=0.4');
};
